<template>
  <el-dialog title :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
    <span class="mx-3">
      <h3 class="text-darkblue mb-3">Your Data</h3>
      <div class="row my-2">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6 class="font-weight-bold text-orange">Name:</h6>
          <p>{{ personalData.name }}</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6 class="font-weight-bold text-orange">Email:</h6>
          <p>{{ personalData.email }}</p>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6 class="font-weight-bold text-orange">Date of Birth:</h6>
          <p>{{ dateFormatter(personalData.dateOfBirth) }}</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6 class="font-weight-bold text-orange">Phone:</h6>
          <p>{{ personalData.phone }}</p>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6 class="font-weight-bold text-orange">Gender:</h6>
          <p>{{ personalData.gender }}</p>
        </div>
      </div>
      <div class="row my-2">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h6 class="font-weight-bold text-orange">Address:</h6>
          <p>{{ personalData.address }}</p>
        </div>
      </div>
      <div class="row mt-3 mx-1">
        <div>
          <h3 class="text-darkblue mb-3">Your Answers</h3>
        <div name="1" v-for="(ans, k) in answersData" :key="`ans-${k}`" class="mb-4">
          <p class="font-weight-bold mb-1">{{ ans.question }}</p>
          <div class="text-muted">{{ ans.answer }}</div>
        </div>
        </div>
      </div>
      <div class="row mt-3 mx-1">
        <div>
          <div>
            <h5 class="text-darkblue">Upload your CV</h5>
            <small class="text-lightgrey mb-5">PDF file not bigger than 5MB</small>
          </div>
          <input
            type="file"
            ref="file"
            accept="application/pdf"
            @change="toDataUrl($event)"
            class="d-none"
            name="pdf"
            v-validate="'required'"
            data-vv-as="PDF File"
          />
          <button
            class="btn btn-primary mt-3"
            type="button"
            @click="setClick"
            v-if="!fileName"
          >Choose File</button>
          <div class="d-flex align-items-center" v-else>
            <p class="mr-2 text-center mb-0">{{fileName}}</p>
            <el-button type="text" @click="removeFile">
              <span class="text-danger">
                <i class="el-icon-delete"></i>
              </span>
            </el-button>
          </div>
          <small class="text-danger">{{ errors.first('pdf') }}</small>
        </div>
      </div>
      <hr />
      <div class="my-3">
        <el-checkbox v-model="checked">Yes, I am comitted to make this 4 months journery</el-checkbox>
      </div>
      <div class="send-application w-100 d-flex justify-content-center">
        <button
          class="btn btn-primary"
          @click="submitApplication"
          type="button"
          :class="[!fileName ? 'disabled' : '']"
          :disabled="!fileName || !checked"
        >Sign Me Up!</button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios';
import { startCase } from 'lodash';
import moment from 'moment';

export default {
  props: {
    preview: Object,
    dialogVisible: Boolean
  },
  data() {
    return {
      path: null,
      fileName: "",
      maxSize: 5120,
      activeName: '',
      selectedFile: {
        fileName: "",
        encoding: "base64",
        content: null
      },
      checked: false,
      csvFile: {
        fileName: 'Applicant Data',
        encoding: 'base64',
        content: null,
      },
    };
  },
  methods: {
    setClick() {
      this.$nextTick(() => {
        this.$refs.file.click();
      });
    },
    toDataUrl(event) {
      const file = event.target.files[0];
      if (file.size >= this.maxSize * 1024) {
        this.$notify.error({
          title: "File too big",
          message: `File ${file.name}( ${(file.size / 1000000).toFixed(
            1
          )} Mb) exceeded the maximum limit of file size 5MB`
        });
      } else {
        this.fileName = file.name;
        const reader = new FileReader();
        const fileName = file.name;
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64 = reader.result.split(",")[1];
          this.selectedFile.content = base64;
          this.selectedFile.fileName = fileName;
        }; 
      }
    },
    handleClose() {
      this.$emit("closeDialog");
    },
    removeFile() {
      Object.keys(this.selectedFile).forEach(key => {
        this.selectedFile[key] = "";
      });
      this.$refs.file.value = "";
      this.fileName = "";
      this.$message.error("File removed.");
    },
    dateFormatter(date) {
      return moment(date).format('DD MMMM YYYY');
    },
    submitApplication() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          const {
            name,
            email,
            phone,
            gender,
            address,
            university,
            major,
            dateOfBirth,
            radio,
          } = this.personalData;

          const question = this.answersData;

          const rows = [
            ["Name", `${name}`],
            ["Email", `${email}`],
            ["Gender", `${gender}`],
            ["Phone", `${phone}`],
            ["Date of Birth", `${this.dateFormatter(dateOfBirth)}`],
            ["Address", `${address.replace(/,/gi, '')}`],
            ["Which one are you?", `${startCase(radio)}`],
            ["University", `${university}`],
            ["Major", `${major}`],
            [`${question[0].question.replace(/,/gi, '')}`, `${question[0].answer.replace(/,/gi, '')}`],
            [`${question[1].question.replace(/,/gi, '')}`, `${question[1].answer.replace(/,/gi, '')}`],
            [`${question[2].question.replace(/,/gi, '')}`, `${question[2].answer.replace(/,/gi, '')}`],
            [`${question[3].question.replace(/,/gi, '')}`, `${question[3].answer.replace(/,/gi, '')}`],
          ];
        
          let csvContent = rows.map(e => e.join(",")).join("\r\n");
          this.csvFile.content = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
          console.log(this.csvFile.content);

          const data = {
            name: this.personalData.name,
            csvFile: this.csvFile.content,
            selectedFile: this.selectedFile,
          };

          axios.post('https://us-central1-orbit-591b7.cloudfunctions.net/app/v1/api/send',data).then(
              () => {
                this.$notify.success({
                  title: "Success!",
                  message: 'Application successfully submitted!',
                });
                this.$emit('closeDialog');
                this.$router.push({name: 'SignUpComplete'})
              }
            ).catch((err) => {
              this.$message.error(err);
            });
          }
      });
    },
  },
  computed: {
    personalData() {
      return this.$store.getters.getPersonalData;
    },
    answersData() {
      return this.$store.getters.getAnswerData;
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.accordion div .el-collapse-item__header {
  line-height: 1px !important;
}

.el-collapse-item__header {
  line-height: 18px !important;
}
</style>